export default "__VITE_ASSET__Dc1IXXto__"